import { Box, Text, Center, Container } from '@chakra-ui/react';
import { DefaultLayout } from '../templates/DefaultLayout';
import { PageSendButton } from '../atom/button/PageSendButton';

import { MaintenanceAlert } from '../molecules/MaintenanceAlert';
import { useMenu } from '../hooks/useMenu';

export const SelectMenu = () => {
  const { isMaintenance, onHandleNewClick, onHandleConfirmClick } = useMenu();

  return (
    <>
      <DefaultLayout>
        <Container maxW="container.md">
          <Box m={5}>
            <Box mt={10} mb={8}>
              {isMaintenance ? (
                <MaintenanceAlert />
              ) : (
                <Text mb={4}>お申し込みの種類を選択してください。</Text>
              )}
            </Box>
            <Center>
              <Box w={'50%'} maxW={'300px'} m={1}>
                <PageSendButton
                  text="新規予約"
                  type="button"
                  onClick={onHandleNewClick}
                  disabled={isMaintenance}
                ></PageSendButton>
              </Box>
              <Box w={'50%'} maxW={'300px'}>
                <PageSendButton
                  text="予約の確認・変更"
                  type="button"
                  onClick={onHandleConfirmClick}
                  disabled={isMaintenance}
                ></PageSendButton>
              </Box>
            </Center>
          </Box>
        </Container>
      </DefaultLayout>
    </>
  );
};
